import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';

// Detectar se é app cliente ou admin
const hostname = window.location.hostname;

// Verificar variável de ambiente (para builds específicos/mobile)
const appMode = process.env.REACT_APP_MODE;

// PRIORIDADE 1: Detectar pelo hostname (produção com ambos subdomínios no mesmo projeto)
const isHostnameCliente = hostname.startsWith('cliente.') || hostname.startsWith('app.');
const isHostnameGestao = hostname.startsWith('gestao.') || hostname.startsWith('admin.') || hostname.startsWith('painel.');

// PRIORIDADE 2: Se não detectou pelo hostname, usa env var (mobile/builds específicos)
const isForcedClient = !isHostnameGestao && !isHostnameCliente && appMode === 'cliente';
const isForcedGestao = !isHostnameGestao && !isHostnameCliente && appMode === 'gestao';

// Subdomínios que abrem o app de gestão
const isGestaoApp = isHostnameGestao || 
                    isForcedGestao ||
                    (hostname === 'localhost' && window.location.pathname.startsWith('/gestao'));

// Lógica do cliente: hostname cliente, ou forçado, ou tem slug na URL
// IMPORTANTE: Se for gestão, NÃO é cliente
const isClientApp = !isGestaoApp && (
                    isHostnameCliente ||
                    isForcedClient || 
                    window.location.pathname.startsWith('/cliente') || 
                    window.location.search.includes('slug=')
                    );

console.log('🚀 index.js - URL:', window.location.href);
console.log('🚀 index.js - appMode (env):', appMode);
console.log('🚀 index.js - isClientApp:', isClientApp);
console.log('🚀 index.js - isGestaoApp:', isGestaoApp);

const root = ReactDOM.createRoot(document.getElementById('root'));

// Se for build nativo de cliente (com slug ou ID fixo), devemos carregar o App normal
// pois ele já lida com a lógica de slug/ID via env var
const temSlugFixo = process.env.REACT_APP_BARBEARIA_SLUG;
const temIdFixo = process.env.REACT_APP_BARBEARIA_ID;

console.log('🔍 Verificando env vars:');
console.log('   REACT_APP_BARBEARIA_SLUG:', temSlugFixo);
console.log('   REACT_APP_BARBEARIA_ID:', temIdFixo);

if (isClientApp && !temSlugFixo && !temIdFixo) {
  console.log('✅ Carregando App CLIENTE MULTITENANT (Web)');
  // Importação dinâmica do app cliente multitenant (só para web dinâmica)
  import('./components/ClientAppMultitenant').then(({ default: ClientAppMultitenant }) => {
    root.render(
      <React.StrictMode>
        <ClientAppMultitenant />
      </React.StrictMode>
    );
  });
} else {
  // Carrega App padrão se:
  // 1. For gestão
  // 2. For build nativo cliente com slug ou ID fixo (usa ClienteWrapper do App.js)
  // 3. Não for identificado (fallback)
  console.log('✅ Carregando App PADRÃO (Gestão ou Cliente Fixo)');
  
  // Se estiver em localhost e acessando /gestao, força o modo gestao mesmo se o env for cliente
  const finalMode = (window.location.hostname === 'localhost' && window.location.pathname.startsWith('/gestao')) 
                    ? 'gestao' 
                    : (isGestaoApp ? 'gestao' : 'cliente');

  import('./App').then(({ default: App }) => {
    root.render(
      <React.StrictMode>
        <App initialMode={finalMode} />
      </React.StrictMode>
    );
  });
}

reportWebVitals();